import React, { useContext } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { EmissaoContext } from "../contexts/EmissaoContext";

import { Margin } from "../styles/Emissao";

const TabEmissaoB2B = ({ ...props }) => {
  const {
    productB2BNumber,
    setProductB2BNumber,
    productB2BItem,
    setProductB2BItem,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly } = useContext(EmissaoContext);

  return (
    <Grid container spacing={2}>
      <Grow in={true}>
        <Grid item lg={12} sm={12}>
          <Card line="left">
            <Margin top="10">
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6}>
                  <TextField
                    value={productB2BNumber}
                    setValue={setProductB2BNumber}
                    size="small"
                    label="Número do pedido de compra"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={6} sm={6}>
                  <TextField
                    value={productB2BItem}
                    setValue={setProductB2BItem}
                    size="small"
                    label="Item do pedido de compra"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoB2B;
